/**
 * creates a success result
 * @param {*} value - the success value (optional)
 * @returns {object} result representing a successful operation
 */
export const success = (value) => {
  return {
    kind: 'success',
    value
  }
}

/**
 * creates a failure result
 * @param {*} error - the error value (optional)
 * @returns {object} result representing a failed operation
 */
export const failure = (error) => {
  return {
    kind: 'failure',
    value: error
  }
}

/**
 * type guard to check if a result is a success
 * @param {object|null} result - the result to check
 * @returns {boolean} true if the result is a success, false otherwise
 */
export const isSuccess = (result) => result?.kind === 'success'

/**
 * type guard to check if a result is a failure
 * @param {object|null} result - the result to check
 * @returns {boolean} true if the result is a failure, false otherwise
 */
export const isFailure = (result) => result?.kind === 'failure'
